import React, { FunctionComponent } from 'react';
import { ImageAndTextbox } from '../..';
import { ProductDataWidget } from '../../../../../../generated/graphql';
import { IAlignment, IButtonPicker, IImage, IImageBreakpoint, ITextEditor } from '../../../../models/campaign-pages/common.model';
import { IImageTextBoxWidget } from '../../../../models/campaign-pages/widgets/image-and-textbox/image-and-textbox.model';

export type ProductWidgetProps = {
  product: ProductDataWidget;
  isContainerFullHeight?: boolean;
};

export const ProductWidget: FunctionComponent<ProductWidgetProps> = (props: ProductWidgetProps) => {
  const image: IImage = { originalImageUrl: props.product.imageUrl, url: props.product.imageUrl, width: '100%' };

  let text: ITextEditor[] = [props.product.title];
  if (props.product.advertText) text = text.concat(props.product.advertText);

  let imageAndTextbox: IImageTextBoxWidget = {
    backgroundColour: '#ffffff',
    button: {
      icon: null,
      style: 'primary',
      text: props.product.buttonText,
      type: 'buttonWithText',
      __typename: 'ButtonPicker',
    } as IButtonPicker,
    buttonVerticalAlignment: {
      desktop: 'bottom',
      mobile: 'bottom',
      __typename: 'Alignment',
    } as IAlignment,
    buttonHorizontalAlignment: {
      desktop: 'center',
      mobile: 'center',
      __typename: 'Alignment',
    } as IAlignment,
    image: {
      desktop: image,
      tablet: image,
      mobile: image,
      alt: props.product.title.text,
      description: undefined,
      __typename: 'Image',
    } as IImageBreakpoint,
    imageDesktopPosition: 'top',
    imageMobilePosition: 'top',
    link: props.product.link,
    opacity: '100%',
    text: text,
    textAlignment: {
      desktop: 'top',
      mobile: 'top',
      __typename: 'Alignment',
    } as IAlignment,
    __typename: 'ImageTextBoxWidget',
  };

  return (
    <ImageAndTextbox
      isContainerFullHeight={props.isContainerFullHeight}
      imageTextBox={imageAndTextbox}
      isBtnFullWidth={true}
      maxImgHeight={258}
    />
  );
};

export default ProductWidget;
